import { useQuery } from "@tanstack/vue-query";
import { computed, type Ref, unref } from "vue";
import User from "@/services/user";

export interface UsersParams {
  organizationId: string;
}

export function useUsers(params: Ref<UsersParams | null> | UsersParams | null) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["users", "disabled"];
    return ["users", p.organizationId];
  });

  const enabled = computed(() => {
    const p = unref(params);
    return p !== null && p !== undefined;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      if (!p) throw new Error("Parameters not ready");

      const result = await User.getUsers(p);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to load users");
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
